module.exports = __webpack_public_path__ + "img/SEGURIFY_comparador_1.c6617463.png";